export default __webpack_public_path__ + "static/media/ic_solomon_islands.aba9f34e.svg";